import { render, staticRenderFns } from "./otherRole.vue?vue&type=template&id=8ac0ff0e&scoped=true&"
import script from "./otherRole.vue?vue&type=script&lang=js&"
export * from "./otherRole.vue?vue&type=script&lang=js&"
import style0 from "./otherRole.vue?vue&type=style&index=0&id=8ac0ff0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac0ff0e",
  null
  
)

export default component.exports